import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Switch } from '@mui';
import { withStyles } from 'tss-react/mui';
import ControlLabel from './control-label';
import './form.scss';

const CustomFormControlLabel = withStyles(FormControlLabel, {
  root: {
    marginLeft: 0  // Fix margin problem when using the 'end' label placement.
  }
});

const SwitchControl = ({ disabled, label, labelPlacement, onChange, value }) => {
  const handleChange = useCallback(event => onChange(event.target.checked), [onChange]);

  return (
    <div data-testid="switch-control" styleName="control-container switch-control">
      <FormControl component="fieldset">
        <CustomFormControlLabel
          disabled={disabled}
          control={
            <Switch
              checked={value}
              color="primary"
              onChange={handleChange}
              size="small"
            />
          }
          labelPlacement={labelPlacement}
          label={<ControlLabel disabled={disabled} label={label} />}
        />
      </FormControl>
    </div>
  );
};

SwitchControl.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelPlacement: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.bool
};


SwitchControl.defaultProps = {
  labelPlacement: 'end'
};

export default SwitchControl;
